import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import TeamMembers from './pages/TeamMembers';
import Store from './pages/Store';
import Customizer from "./pages/Customizer";
import CustomDesign from "./pages/CustomDesign";
import CustomProjects from "./pages/CustomProjects";
import CustomProjectDetail from "./pages/CustomProjectDetail";
import Stories from './pages/Stories';
import Header from './components/Header';
import Footer from './components/Footer';
import YoYoPage from './pages/YoYoPage';
import Cart from './pages/Cart';
import CheckoutPage from './pages/CheckoutPage';
import ContactForm from "./pages/ContactForm";
import { CartProvider } from './pages/CartContext';
import { AuthProvider } from './pages/AuthContext';
import Modal from './components/Modal';
import AdminProducts from "./pages/AdminProducts";
import AdminRadar from './pages/AdminRadar';
import AdminAnalytics from './pages/AdminAnalytics';
import AdminUsers from './pages/AdminUsers';
import AnalyticsTracker from './components/AnalyticsTracker';
import AdminCustomRequests from "./pages/AdminCustomRequests";
import AdminOrders from "./pages/AdminOrders";
import BlitzballVsWindBallGuide from './pages/BlitzballVsWindBallGuide';
import ShippingPolicy from './pages/ShippingPolicy';
import NotFoundPage from './pages/NotFoundPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Account from './pages/Account';
import CommunityForum from './pages/CommunityForum';
import CommunityScoring from './pages/CommunityScoring';
import AdminCommunity from './pages/AdminCommunity';
import AdminCustomProjects from './pages/AdminCustomProjects';
import { I18nProvider, useI18n } from './i18n/I18nContext';
import './App.css';


function AppContent() {
  const { t } = useI18n();
  const [messageKey, setMessageKey] = useState("");
  const [showModal, setShowModal] = useState(false);


  useEffect(() => {
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessageKey('app.orderSuccess');
      setShowModal(true);
    }

    if (query.get("canceled")) {
      setMessageKey('app.orderCanceled');
      setShowModal(true);
    }
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    setMessageKey('');
  };

  return(
    <AuthProvider>
    <CartProvider>
    <div className="app-container">
      <Router>
        <AnalyticsTracker />
        <Header />
        <div className="main-content">
        {showModal && <Modal message={t(messageKey)} onClose={handleCloseModal} />}
          <Routes>
            <Route path='/' element={<Home/>} />
            <Route path='/team' element={<TeamMembers/>} />
            <Route path='/store' element={<Store/>} />
            <Route path='/store/:productSlug' element={<YoYoPage/>} />
            <Route path='/cart' element={<Cart/>} />
            <Route path='/customizer' element={<Customizer/>} />
            <Route path='/custom-design' element={<CustomDesign/>} />
            <Route path='/account/custom-projects' element={<CustomProjects/>} />
            <Route path='/account/custom-projects/:projectId' element={<CustomProjectDetail/>} />
            <Route path='/stories' element={<Stories/>} />
            <Route path='/checkout' element={<CheckoutPage />} />
            <Route path='/contact' element={<ContactForm />} />
            <Route path='/shipping' element={<ShippingPolicy />} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<Register />} />
            <Route path='/account' element={<Account />} />
            <Route path='/community' element={<CommunityForum />} />
            <Route path='/community/articles/:articleId' element={<CommunityForum />} />
            <Route path='/community/scoring/:videoId?' element={<CommunityScoring />} />
            <Route path='/admin' element={<AdminProducts />} />
            <Route path='/admin/radar' element={<AdminRadar />} />
            <Route path='/admin/analytics' element={<AdminAnalytics />} />
            <Route path='/admin/users' element={<AdminUsers />} />
            <Route path='/admin/custom-requests' element={<AdminCustomRequests />} />
            <Route path='/admin/custom-projects' element={<AdminCustomProjects />} />
            <Route path='/admin/orders' element={<AdminOrders />} />
            <Route path='/admin/community' element={<AdminCommunity />} />
            <Route path='/guides/blitzball-vs-windball' element={<BlitzballVsWindBallGuide />} />
            <Route path='*' element={<NotFoundPage />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
    </CartProvider>
    </AuthProvider>
  );
}

function App() {
  return (
    <I18nProvider>
      <AppContent />
    </I18nProvider>
  );
}

export default App;
